import React from "react";
import {
  HomeIcon as IconHome,
  IconButton,
  PicklebetIcon,
  ReloadIcon as IconReload,
  Typography,
} from "@picklebet/ui";
import { isWebView } from "utilities/display";
import { getBridge } from "utilities/bridge";
import { ReactComponent as PageErrorIcon } from "assets/illustrations/page-error.svg";
import * as styles from "./FullScreenError.module.scss";

type FullScreenErrorProps = {
  title: string;
  message: React.ReactNode;
};

export const FullScreenError = ({ title, message }: FullScreenErrorProps) => {
  const reloadPage = () => {
    if (isWebView()) {
      getBridge().send.reload();
    } else {
      location.reload();
    }
  };

  const goHome = () => {
    location.href = "/";
  };

  return (
    <div className={styles.errorPage}>
      <header className={styles.logo} onClick={goHome}>
        <PicklebetIcon className={styles.logo} />
      </header>

      <section>
        <div>
          <PageErrorIcon className={styles.img} />
          <Typography className={styles.centered} variant="h2">
            {title}
          </Typography>
          <Typography className={styles.centered}>{message}</Typography>

          <div className={styles.actionButtons}>
            <IconButton label="Reload" onClick={reloadPage}>
              <IconReload />
            </IconButton>
            <IconButton label="Go Home" variant="secondary" onClick={goHome}>
              <IconHome />
            </IconButton>
          </div>
        </div>
      </section>
    </div>
  );
};
